import http from "../config/axiosConfig/http-common";
import ServiceBase from "./service.base";

class PedidoService extends ServiceBase {

  getAll(filter) {
    //return http.get("/clientes?$top=10");
    return http.get("/pedidosvenda" + this.getFilter(filter));
  }

  get(id) {
    return http.get(`/pedidosvenda/${id}`);
  }

  getItensPedido(id, filter) {
    return http.get(`/ItensPedidoVenda/Pedido/${id}${this.getFilter(filter)}`);
  }

  getItensCliente(idCliente, filter) {
    return http.get(`/ItensPedidoVenda/clientes/${idCliente}${this.getFilter(filter)}`);
  }

  getItemPedido(id) {
    return http.get(`/ItensPedidoVenda/${id}`);
  }

  getComposicaoItem(id) {
    return http.get(`/ItensPedidoVenda/${id}/composicao`);
  }

  notas(id, filter){
    return http.get(`/pedidosvenda/${id}/notas${this.getFilter(filter)}`)
  }

  ListVendedor(filter) {
    return http.get(`/pedidosvenda/ListVendedor${this.getFilter(filter)}`)
  }

  GetListaRelatoriosCustomizados(id) {
    return http.get(`/pedidosvenda/${id}/ListagemImpressoes`);
  }

  ImprimirRelatorio(link) {
    return http.get(link,
      {
        responseType: "blob",
      });
  }

  ImprimirSaldoPendenciaPedidoVenda(id) {
    return http.get(`/pedidosvenda/${id}/GerarRelatorio/SaldoPendenciaPedidoVenda/Principal/1`, { responseType: "blob" });
  }

}

export default new PedidoService();